// resources/js/src/components/community/stories/StoryItem.tsx
import React from "react";

interface StoryItemProps {
  username: string;
  profilePic: string | null;
  seen: boolean;
  onClick?: () => void;
}

const StoryItem: React.FC<StoryItemProps> = ({
  username,
  profilePic,
  seen,
  onClick,
}) => {
  const avatarSrc =
    profilePic ||
    `https://ui-avatars.com/api/?name=${encodeURIComponent(
      username
    )}&background=10b981&color=fff&size=128&bold=true`;

  return (
    <div
      className="flex flex-col items-center cursor-pointer"
      onClick={onClick}
    >
      <div
        className={`w-28 h-28 rounded-full p-1 border-2 ${
          seen
            ? "border-slateGray"
            : "dark:border-primary border-tealGreen"
        }`}
      >
        <img
          src={avatarSrc}
          alt={username}
          className="w-full h-full rounded-full object-cover"
          onError={(e) => {
            (e.target as HTMLImageElement).src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
              username
            )}&background=10b981&color=fff&size=128&bold=true`;
          }}
        />
      </div>
      <span className="text-xs mt-2 truncate w-24 text-center dark:text-muted">
        {username}
      </span>
    </div>
  );
};

export default StoryItem;